<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'mainwire')"

  >

    <template #addDataForm>
      <mainWire-add-update></mainWire-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">

        <template v-if="cell.field.key === 'main_wire'">
            <template v-if="get(cell.item, 'id')">
                <main-wire-cell :data="cell.item"></main-wire-cell>
            </template>
            <template v-else>
                {{cell.item}}
            </template>
        </template>
        <template v-else-if="cell.field.key === 'opora'">
            <template v-if="get(cell.value, 'id')">
                <pillar-cell :data="cell.value"></pillar-cell>
            </template>

        </template>

        <template v-else-if="cell.field.key === 'user'">
            <template v-if="get(cell.value, 'id')">
                <user-cell :user="cell.value"></user-cell>
            </template>

        </template>
    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../mainWireStoreModule'
  import useMainWire from '../useMainWire'

  import MainWireAddUpdate from '../components/MainWireAddUpdate'
  import MainWireCell from "@/views/apps/railway_structure/mainWire/components/MainWireCell";

  import get from 'lodash.get'
  import UserCell from "@/views/apps/user/components/UserCell";
  import PillarCell from "@/views/apps/railway_structure/pillar/components/PillarCell";

  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
        PillarCell,
        UserCell,
      MainWireCell,
      ElementsLayout,
      MainWireAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = useMainWire();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
